<div class="step-content">
    <div class="header-section pad-2">
        <button class="back-link" (click)="onBack()">
            ← Enter location address and sign forms
        </button>
    </div>

    <div class="location-info-section">
        <div class="section-title">Location Info</div>

        <form [formGroup]="locationFormGroup" class="form-grid">
        <div class="form-group">
            <app-text-input [label]="'TIN'" [for]="'Tin-Input'" [placeholder]="''"
                [ngClass]="locationFormGroup.controls['tin'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['tin']" [fieldType]="'This field'"
                [errorMessages]="customErrorMessagesSsn"
                [maxLength]="FIELD_LIMITS['tin']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'Location name'" [for]="'location-Input'" [placeholder]="''"
                [title]="(locationFormGroup.controls['name'].value?.length || 0) > 25 ? (locationFormGroup.controls['name'].value || '') : ''"
                [ngClass]="locationFormGroup.controls['name'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['name']" [errorMessages]="customErrorMaxLength"
                [maxLength]="FIELD_LIMITS['name']['maxLength']">
            </app-text-input>
        </div>

        <div class="form-group">
            <div class="marg-t-35 find-wdth">
                <label class="location-field" for="location-name">Address 1 <span class="asterisk"
                        *ngIf="locationFormGroup.controls['location'].errors">*</span></label>
                <input (focus)="onFocus()" (blur)="onBlur($event)" formControlName="location"
                    (ngModelChange)="onLocationChange($event)" #locationInput type="text"
                    id="location-name" name="location" aria-label="Service address"
                    [title]="(locationFormGroup.controls['location'].value?.length || 0) > 25 ? (locationFormGroup.controls['location'].value || '') : ''"
                    class="findform-input location-fieldbox" [maxLength]="FIELD_LIMITS['address']['maxLength']" />
                <div *ngIf="!showStateError && showError" class="finddentist-validator">Required</div>
                <div *ngIf="(showStateError && (locationFormGroup.controls['state']?.errors) )" class="finddentist-validator">
                    {{ stateRestrictionMessage }}
                </div>
                <div *ngIf="(!showStateError && showFulladdressError) && (locationFormGroup.controls['zip']?.errors) " class="finddentist-validator">Please type full home
                    address</div>
            </div>
        </div>

        <div class="form-group">
            <app-text-input [label]="'City'" [for]="'City-Input'" [placeholder]="''"
                [ngClass]="locationFormGroup.controls['city'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['city']" [errorMessages]="customErrorCity"
                [maxLength]="FIELD_LIMITS['city']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <app-select-input class="story-drop" [for]="'LicenseState-select'" [label]="'State'" [placeholder]="''"
                [ngClass]="locationFormGroup.controls['state'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [options]="filteredStateOptions" [placeholder]="'None selected'"
                [control]="locationFormGroup.controls['state']">
            </app-select-input>
        </div>

        <div class="form-group">
            <app-text-input [label]="'ZIP'" [for]="'ZIP-Input'" [placeholder]="''"
                [ngClass]="locationFormGroup.controls['zip'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['zip']" [fieldType]="'This field'"
                [errorMessages]="customErrorMessagesZip"
                (paste)="restrictNonNumericPaste($event)"
                (keypress)="restrictNonNumeric($event)" 
                [maxLength]="FIELD_LIMITS['zip']['maxLength']"></app-text-input>
        </div>

        <div class="form-group">
            <fieldset class="radio-fieldset">
                <legend class="radio-legend">Primary location <span class="clr-red"
                        *ngIf="primaryLocationFormGroup.controls['isPrimary'].errors">*</span></legend>
                <div class="radio-group">
                    <app-radio layout="horizontal" [formGroup]="primaryLocationFormGroup" [label]="''"
                        [for]="'SearchBasedOn-Input'" [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]"
                        (changed)="checkPrimaryExist(primaryLocationFormGroup.get('isPrimary')?.value)"
                        id="rdSearchBasedOn">
                    </app-radio>
                </div>
            </fieldset>
            <div *ngIf="showIsprimaryError" class="finddentist-validator">Primary location is already selected for an existing location.</div>
        </div>

        <div class="form-group" *ngIf="(isWhLocation && !isLocationFromTinSearch) && isPar">
            <fieldset class="radio-fieldset">
                <legend class="radio-legend">Do you still practice at this location?</legend>
                <div class="radio-group">
                    <app-radio layout="horizontal" [formGroup]="practiceFormGroup" [label]="''"
                        [for]="'SearchBasedOn-Input'" [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]"
                        id="rdSearchBasedOn" (changed)="onPracticeChange()">
                    </app-radio>
                </div>
            </fieldset>
        </div>

        <div class="form-group"
            *ngIf="(isWhLocation) && isPar && this.practiceFormGroup.get('isPracticing')?.value === 'no'">
            <app-date-input [label]="'Date ended'" [for]="'dateEnded-select'"
                [control]="locationFormGroup.controls['endDate']"
                [ngClass]="locationFormGroup.controls['endDate'].errors ? 'showAsterisk' : 'hideAsterisk'">
            </app-date-input>
        </div>

        <div class="form-group"
            *ngIf="(isWhLocation && isPar == false) || (!isWhLocation && !isLocationFromTinSearch) || (isLocationFromTinSearch)">
            <fieldset class="radio-fieldset">
                <legend class="radio-legend">Do you intend to make this location participating?</legend>
                <div class="radio-group">
                    <app-radio layout="horizontal" [formGroup]="participatingFormGroup" [label]="''"
                        [for]="'SearchBasedOn-Input'" [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]"
                        id="rdSearchBasedOn" (changed)="onParticpatingChange()">
                    </app-radio>
                </div>
            </fieldset>
        </div>
        <div class="form-group" *ngIf="showDateStartedField">
            <app-date-input [label]="'Date started'" [minDate]="minDate" [for]="'dateStarted-select'"
                [ngClass]="locationFormGroup.controls['startDate'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [errorMessages]="VALIDATION_MESSAGES['startDate']"
                [control]="locationFormGroup.controls['startDate']">
            </app-date-input>
        </div>
        <div class="form-group">
            <app-select-input class="story-drop" [for]="'officeTypeID-select'" [label]="'Office type'"
                [ngClass]="locationFormGroup.controls['officeTypeID'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [placeholder]="'None selected'" [options]="officeTypeIDOptions"
                [control]="locationFormGroup.controls['officeTypeID']">
            </app-select-input>

        </div>
        <div class="form-group">
            <app-text-input [label]="'Location phone'" [for]="'voicePhone-Input'" appPhoneMask
                [ngClass]="locationFormGroup.controls['voicePhone'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['voicePhone']"
                [maxLength]="FIELD_LIMITS['voicePhone']['maxLength']">
            </app-text-input>
        </div>
        <div class="form-group">
            <app-text-input [label]="'Email'" [for]="'email-Input'" [placeholder]="''"
                [title]="(locationFormGroup.controls['email'].value?.length || 0) > 25 ? (locationFormGroup.controls['email'].value || '') : ''"
                [ngClass]="locationFormGroup.controls['email'].errors ? 'showAsterisk' : 'hideAsterisk'"
                [control]="locationFormGroup.controls['email']" [errorMessages]="errormessages"
                [maxLength]="FIELD_LIMITS['email']['maxLength']">
            </app-text-input>
        </div>
        </form>
    </div>

    <app-create-tin *ngIf="showTinAndPayeeSections" [serviceCheckFormInput]="ServiceCheckForm"
        [locationFormGroupInput]="locationFormGroup" [locationMetaInput]="createTinLocationMeta"
        [showW9Section]="showTinAndPayeeSections" [showSaveAction]="isNewTIN"
        (saveCompleted)="onCreateTinSaveCompleted()" (corpAuthCleared)="onCreateTinCorpAuthCleared()"
        [isW9Required]="isW9Required" [shouldDeleteW9OnSave]="shouldDeleteW9OnLocationSave()">
        <div class="sign-section pad-2-side" document-actions-header>
            <h3>Read and sign the required forms.</h3>
            <p class="description-note">Review and sign each form below before submitting.</p>
        </div>

        <div class="sign-section pad-2-side" document-actions *ngIf="((!isWhLocation && !isLocationFromTinSearch && participatingFormGroup.get('isParticipating')?.value == 'yes')
        ||(isPar == false && this.participatingFormGroup.get('isParticipating')?.value == 'yes')
        || (isLocationFromTinSearch && this.participatingFormGroup.get('isParticipating')?.value == 'yes'
        ||primaryLocationFormGroup.get('isPrimary')?.value == 'yes'))">
            <div class="sign-cards">
                <div class="sign-card" *ngIf="(!isWhLocation && !isLocationFromTinSearch && participatingFormGroup.get('isParticipating')?.value == 'yes')
                    ||(!isPar && this.participatingFormGroup.get('isParticipating')?.value == 'yes')
                    || (isLocationFromTinSearch  && this.participatingFormGroup.get('isParticipating')?.value == 'yes')"
                    [class.is-completed]="corporateAuthSigned">
                    <div class="card-content">
                        <div class="icon-wrapper" [class.is-completed]="corporateAuthSigned">
                            📄
                        </div>
                        <strong class="card-title">
                            Corporate authority form
                            <span class="asterisk" *ngIf="!corporateAuthSigned">*</span>
                        </strong>
                    </div>
                    <div class="card-actions">
                        <span class="status-badge" [class.completed]="corporateAuthSigned">
                            {{ corporateAuthSigned ? 'Completed' : 'Not started' }}
                        </span>
                        <button class="btn btn-outline cancel-btn" (click)="onFormReadAndSign()"
                            [ngClass]="{'disabled-btn': isCorpAuthReadAndSignDisabled() && !(impersonatedUser&&corporateAuthSigned)}"
                            [disabled]="isCorpAuthReadAndSignDisabled() && !(impersonatedUser&&corporateAuthSigned)">
                            {{ corporateAuthSigned ? 'View' : 'Read & Sign' }}
                        </button>
                    </div>
                </div>

                <div class="sign-card" *ngIf="primaryLocationFormGroup.get('isPrimary')?.value == 'yes'"
                    [class.is-completed]="directoryInfoSigned || directoryData">
                    <div class="card-content">
                        <div class="icon-wrapper" [class.is-completed]="directoryInfoSigned || directoryData">
                            📄
                        </div>
                        <strong class="card-title">
                            Directory information
                            <span class="asterisk" *ngIf="!(directoryInfoSigned || directoryData)">*</span>
                        </strong>
                    </div>
                    <div class="card-actions">
                        <span class="status-badge" [class.completed]="directoryInfoSigned || directoryData">
                            {{ (directoryInfoSigned || directoryData) ? 'Completed' : 'Not started' }}
                        </span>
                        <button class="btn btn-outline cancel-btn" (click)="onReadAndSign()">{{ (directoryInfoSigned || directoryData) ? 'View' : 'Fill/Verify' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </app-create-tin>
    <div class="actions-section" *ngIf="!isNewTIN">
        <div class="location-save-actions">
            <button class="add-btn cancel-btn" (click)="onCancel()" [disabled]="impersonatedUser">Cancel</button>
            <button class="add-btn save-btn"
                (click)="onSaveClick()"
                [disabled]="impersonatedUser|| disableAddLocation()">{{buttonText}}</button>
        </div>
    </div>

    <app-corp-authority-form *ngIf="showCorpAuthPopup" (close)="onCorpAuthClose()" (done)="onCorpAuthDone($event)"
        (deleteDoc)="onDeleteDocument($event)" [documentData]="documentsMap" [locData]="dataToCorpForm">
    </app-corp-authority-form>

    <app-directory-info-form *ngIf="showDirectoryInfoPopup" (close)="onDirectoryInfoClose()"
        (submit)="onDirectoryInfoSubmit($event)" [directoryInfo]="directoryData">
    </app-directory-info-form>
</div>